export const errorConstants = {
  endDateInPreviousMonth:
    'End date is in a previous month, and will show up in the Pro’s payout in that month, not the month it was created.',
};
